import { lazy } from 'react';

const LazyCheckout = lazy(() => import('./Checkout'));

export default LazyCheckout;
